"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var date_fns_1 = require("date-fns");
var PostDate = /** @class */ (function (_super) {
    __extends(PostDate, _super);
    function PostDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PostDate.prototype.render = function () {
        var date = new Date(this.props.date);
        var formattedDate = (0, date_fns_1.format)(date, this.props.format);
        console.log("Date", date.toString());
        return (react_1.default.createElement("p", { className: "card__date" },
            react_1.default.createElement("time", { dateTime: formattedDate }, formattedDate)));
    };
    PostDate.defaultProps = {
        format: "dd/MM/yyyy"
    };
    return PostDate;
}(react_1.default.Component));
exports.default = PostDate;
